module.exports = __webpack_public_path__ + "img/logo-footer.44d7b14c.png";